import { render } from "./RecentNotifications.vue?vue&type=template&id=45fbf5b6&scoped=true"
import script from "./RecentNotifications.vue?vue&type=script&lang=js"
export * from "./RecentNotifications.vue?vue&type=script&lang=js"

import "./RecentNotifications.vue?vue&type=style&index=0&id=45fbf5b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fbf5b6"]])

export default __exports__